import React, { useEffect, useLayoutEffect, useState } from 'react';
import { onAuthStateChanged } from '@firebase/auth';
import { auth } from '../firebase';

export default function StartupGate({ children }: { children: React.ReactNode }) {
  const [status, setStatus] = useState<'pending' | 'ready' | 'error'>('pending');

  useEffect(() => {
    if (status !== 'pending') return;
    return onAuthStateChanged(auth, () => setStatus('ready'), (error) => {
      console.error('startup-auth-failed', error);
      setStatus('error');
    });
  }, [status]);

  useLayoutEffect(() => {
    if (status !== 'pending') document.getElementById('belivah-startup')?.remove();
  }, [status]);

  if (status === 'error') {
    return (
      <main role="alert" style={{ minHeight: '100vh', display: 'grid', alignContent: 'center', justifyItems: 'center', padding: 24, boxSizing: 'border-box', textAlign: 'center' }}>
        <h1>Unable to open Belivah</h1>
        <p>Please reload to try again.</p>
        <button onClick={() => window.location.reload()}>Reload</button>
      </main>
    );
  }

  return status === 'ready' ? <>{children}</> : null;
}
